import { NgModule } from '@angular/core';
import { RowsVoidsComponent } from './tablerowsvoids/tablerowsvoids.component';
import { CommonModule } from '@angular/common';

@NgModule({
    declarations: [RowsVoidsComponent],
    imports : [CommonModule],
    exports: [RowsVoidsComponent]
})
export class SharedModule {

}

